//@ts-nocheck
import {
  Icon,
  Link,
  PlacementWithLogical,
  Popover,
  PopoverContent,
  PopoverTrigger,
  SimpleGrid,
  SimpleGridProps,
  Stack,
  Text,
  useBoolean,
} from "@chakra-ui/react";
import React from "react";

import {
  FiBarChart,
  FiFileText,
  FiGrid,
  FiMousePointer,
  FiRepeat,
  FiShield,
} from "react-icons/fi";

import { IconType } from "react-icons";

export type DropdownItemType = {
  title?: string;
  description?: string;
  href?: string;
  icon?: string;
};
const icons: { [key: string]: IconType } = {
  shield: FiShield,
  "file-text": FiFileText,
  grid: FiGrid,
  "mouse-pointer": FiMousePointer,
  repeat: FiRepeat,
  "bar-chart": FiBarChart,
};

export const SimpleGridDropdown: React.FC<
  SimpleGridProps & { items: DropdownItemType[] }
> = ({ items, ...rest }) => {
  return (
    <SimpleGrid columns={{ base: 1, md: 2 }} columnGap="6" rowGap="2" {...rest}>
      {items.map((item, id) => {
        const icon = item.icon && icons[item.icon];
        return (
          <Link variant="menu" href={item.href} key={id}>
            <Stack spacing="4" direction="row" p="3">
              {icon ? <Icon as={icon} boxSize="6" color="accent" /> : null}
              <Stack spacing="1">
                <Text fontWeight="medium">{item.title}</Text>
                <Text fontSize="sm" color="muted">
                  {item.description}
                </Text>
              </Stack>
            </Stack>
          </Link>
        );
      })}
    </SimpleGrid>
  );
};

export type MenuItemType = {
  title?: string;
  href?: string;
  image?: string;
  links?: {
    label: string;
    url: string;
  }[];
};

export interface HoverNavDropdown<T> {
  items?: T[];
  render: (isOpen: boolean, onClose?: () => void) => JSX.Element;
  defaultIsOpen?: boolean;
  renderDropdown?: (items: T[]) => JSX.Element;
  placement?: PlacementWithLogical;
}

export const HoverNavDropdown: React.FC<
  HoverNavDropdown<DropdownItemType | MenuItemType>
> = ({
  items = [],
  render,
  defaultIsOpen,
  placement = "bottom",
  renderDropdown = (i) => <SimpleGridDropdown items={i} />,
}) => {
  const [isEditing, setIsEditing] = useBoolean(defaultIsOpen);
  return (
    <Popover
      trigger="hover"
      openDelay={0}
      placement={placement}
      isOpen={isEditing}
      onClose={setIsEditing.off}
      onOpen={setIsEditing.on}
      gutter={25}
    >
      <>
        <PopoverTrigger>
          <span>
            {render(isEditing, isEditing ? setIsEditing.off : setIsEditing.on)}
          </span>
        </PopoverTrigger>
        {isEditing ? (
          <PopoverContent
            background={"white"}
            p="5"
            width={{ base: "sm", md: "2xl" }}
          >
            {renderDropdown(items)}
            {/* <SimpleGridDropdown items={items} /> */}
          </PopoverContent>
        ) : null}
      </>
    </Popover>
  );
};
